<template>
  <div>
    <b-modal
      :active.sync="isModalActive"
      :can-cancel="true"
      :on-cancel="closeModal"
    >
      <b-loading style="z-index: 100;" :is-full-page="true" :can-cancel="false">
        <div class="loading-container">
          <div class="loading">
            <p>loading</p>
            <span></span>
          </div>
        </div>
      </b-loading>

      <div id="editModal" class="modal-container rb">
        <div class="full-height">
          <div class="card-content">
            <div v-if="selectedUsers.length <= 1" class="content">
              <b-field style="padding-bottom:0px; margin-bottom:0px;">
                <header class="card-header">
                  <h1 id="editHeader" class="card-header-title">
                    Edit Learner Details 
                  </h1>
                </header>
              </b-field>
              <!--tab-->
              <b-tabs class="block">
                <b-tab-item label="Update Basic Details">
                  <b-field grouped>
                    <b-field class="editInputField" label="First Name">
                      <b-input
                        class="editBox"
                        :placeholder="changedUser.firstName"
                        v-model="changedUser.firstName"
                      ></b-input>
                    </b-field>
                    <b-field class="editInputField" label="Last Name">
                      <b-input
                        class="editBox"
                        :placeholder="changedUser.lastName"
                        v-model="changedUser.lastName"
                      >
                      </b-input>
                    </b-field>
                    <b-field class="editInputField" label="Preferred Name">
                      <b-input
                        class="editBox"
                        :placeholder="changedUser.preferredName"
                        v-model="changedUser.preferredName"
                      >
                      </b-input>
                    </b-field>
                  </b-field>
                  <b-field
                    class="editInputField"
                    style="width:41.6rem"
                    label="Email"
                  >
                    <b-input
                      class="editBox"
                      :placeholder="changedUser.email"
                      v-model="changedUser.email"
                      type="email"
                    >
                    </b-input>
                  </b-field>
                  <b-field grouped>
                    <b-field
                      id="editDropDown"
                      label="Class"
                      label-position="on-border"
                    >
                      <b-select
                        class="editBox"
                        :placeholder="classes.length > 1 ? 'ALL' : classes[0]"
                        :disabled="classes.length <= 1"
                        v-model="userClass"
                      >
                        <option :value="-1">
                          ALL
                        </option>
                        <option
                          v-for="(option, index) in classes"
                          :value="option"
                          :key="index"
                        >
                          {{ option }}
                        </option>
                      </b-select>
                    </b-field>
                    <b-field
                      id="editDropDown"
                      :label="contextualGradeLabel()"
                      label-position="on-border"
                    >
                      <b-select
                        class="editBox"
                        :placeholder="filteredGrade"
                        :disabled="grades.length === 1"
                        v-model="grade"
                      >
                        <option
                          v-for="(option, index) in grades"
                          :value="option"
                          :key="index"
                        >
                          {{
                            option == 13
                              ? "Adult"
                              : contextualSpecificGradeAndLabelMin(option)
                          }}
                        </option>
                      </b-select>
                    </b-field>
                    <b-field
                      id="editDropDown"
                      label="Country"
                      label-position="on-border"
                    >
                      <b-select
                        class="editBox"
                        :placeholder="changedUser.country"
                        v-model="countryName"
                        :disabled="true"
                      >
                        <option
                          v-for="(option, index) in countries"
                          :value="option.value"
                          :key="index"
                        >
                          {{ option.name }}
                        </option>
                      </b-select>
                    </b-field>
                  </b-field>
                  <b-field class="editInputField" label="Subscription">
                    <b-datepicker
                      class="editBox"
                      style="width:41rem"
                      :placeholder="
                        changedUser.subscription.endDate != null
                          ? changedUser.subscription.endDate
                              .toString()
                              .substring(0, 10)
                          : 'Select a date...'
                      "
                      v-model="subscriptionDate"
                      position="is-top-left"
                      :disabled="true"
                    >
                    </b-datepicker>
                  </b-field>
                  <!-- footer -->
                  <footer class="card-footer" style="margin-top:5em">
                    <b-button
                      id="tableBtn"
                      @click="saveChanges"
                      class="tag is-primary"
                      size="is-medium"
                      outlined
                      >Update User</b-button
                    >
                    <b-button
                      id="tableBtn"
                      @click="closeModal"
                      class="tag is-dark"
                      size="is-medium"
                      outlined
                      >Cancel</b-button
                    >
                  </footer>
                </b-tab-item>

                <!--change password tab-->
                <b-tab-item label="Change Learner Password" v-if="this.isInternal">
                  <div class="change-password">
                    <div class="change-password-child">
                      <div class="change-password-child-inner">
                        <p class="has-text-weight-bold">
                          Email:
                          <span class="has-text-weight-normal">{{
                            changedUser.email
                          }}</span>
                        </p>
                      </div>
                      <b-field
                        style="width:100%; margin-top:5%"
                        label="New Password"
                      >
                        <b-input
                          style="width:100%; margin-bottom:8%"
                          class="editBox"
                          password-reveal
                          v-model="passwordReset"
                          type="password"
                        >
                        </b-input>
                      </b-field>
                    </div>
                  </div>
                  <!-- footer -->
                  <footer class="card-footer" style="margin-top:5em;">
                    <div v-if="selectedUsers.length <= 1">
                      <b-button
                        id="tableBtn"
                        @click="updatePassword"
                        class="tag is-primary"
                        size="is-medium"
                        outlined
                        >Update Password</b-button
                      >
                    </div>
                    <b-button
                      id="tableBtn"
                      @click="closeModal"
                      class="tag is-dark"
                      size="is-medium"
                      outlined
                      >Cancel</b-button
                    >
                  </footer>
                </b-tab-item> 

                <!-- Update Assessment Tab -->
                <b-tab-item label="Upgrade Assessment" v-if="this.isInternal">
                  <div class="change-assessment">
                    <table>
                      <tr>
                        <th>Subject</th>
                        <th>Assessment</th>
                        <th>Change Assessment</th>
                      </tr>
                      <tr v-for="assessmentState in assessmentUpgrades" :key="assessmentState._id">
                        <td style="vertical-align: middle;"> {{ assessmentState.subject }} </td>
                        <td style="vertical-align: middle;"> {{ assessmentState.type }} </td>
                        <td>
                          <select v-model="assessmentState.newType" class="select is-fullwidth" :class="{ 'is-primary': assessmentState.newType != null }">
                            <option :value="null">Select New Assessment</option>
                            <option v-for="option in getUpgradeOptions(assessmentState)" :key="option" :value="option" :disabled="isDisabledOption(assessmentState, option)">
                              {{ option }}
                            </option>
                          </select>
                        </td>
                      </tr>
                    </table>

                    <!-- <pre>{{ assessmentUpgrades }}</pre> -->

                    <div class="is-flex ">
                      <b-button
                        @click="processUpgrades"
                        class="tag is-primary mr-4"
                        size="is-medium"
                        outlined
                        :disabled="assessmentUpgrades.every(upgrade => upgrade.newType === null)"
                        >Upgrade Selected Assessments</b-button
                      >
                      <b-button
                        @click="closeModal"
                        class="tag is-dark"
                        size="is-medium"
                        outlined
                        >Cancel</b-button
                      >
                    </div>
                  </div>
                </b-tab-item>
              </b-tabs>
            </div>

            <div v-else class="content">
              <b-field>
                <header class="card-header">
                  <h1 id="bulkHeader" class="card-header-title">
                    Edit Selected Learners
                  </h1>
                </header>
              </b-field>
              <b-field grouped>
                <b-field
                  id="editDropDown"
                  label="Class"
                  label-position="on-border"
                >
                  <b-select
                    class="editBox"
                    :placeholder="classes.length > 1 ? 'ALL' : classes[0]"
                    :disabled="classes.length <= 1"
                    v-model="userClass"
                  >
                    <option :value="-1">
                      ALL
                    </option>
                    <option
                      v-for="(option, index) in classes"
                      :value="option"
                      :key="index"
                    >
                      {{ option }}
                    </option>
                  </b-select>
                </b-field>
                <b-field
                  id="editDropDown"
                  :label="contextualGradeLabel()"
                  label-position="on-border"
                  type="is-light"
                >
                  <b-select
                    :placeholder="filteredGrade"
                    :disabled="grades.length === 1"
                    v-model="grade"
                  >
                    <option
                      v-for="(option, index) in grades"
                      :value="option"
                      :key="index"
                    >
                      {{
                        option == 13
                          ? "Adult"
                          : contextualSpecificGradeAndLabelMin(option)
                      }}
                    </option>
                  </b-select>
                </b-field>
                <b-field
                  id="editDropDown"
                  label="Country"
                  label-position="on-border"
                >
                  <b-select
                    placeholder="Click to select..."
                    v-model="countryName"
                    :disabled="true"
                  >
                    <option
                      v-for="(option, index) in countries"
                      :value="option.value"
                      :key="index"
                    >
                      {{ option.name }}
                    </option>
                  </b-select>
                </b-field>
              </b-field>
              <b-field class="editInputField" label="Subscription">
                <b-datepicker
                  class="editBox"
                  style="width:24.5rem"
                  placeholder="Click to select..."
                  v-model="subscriptionDate"
                  :disabled="true"
                >
                </b-datepicker>
              </b-field>
              <footer class="bulk-footer">
                <b-button
                  id="tableBtn"
                  @click="saveMultiple"
                  class="tag is-primary"
                  size="is-medium"
                  outlined
                  >Update Learners</b-button
                >
                <b-button
                  id="tableBtn"
                  @click="closeModal"
                  class="tag is-dark"
                  size="is-medium"
                  outlined
                  >Cancel</b-button
                >
              </footer>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
@import "../styles/bulkLearner.scss";
@import "../styles/editBothCards.scss";
</style>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import localizationMixin from "@/modules/global/mixins/localizationMixin.js";
import authservice from "@/modules/auth/services/auth-services.js";
import { ToastProgrammatic as Toast } from "buefy";
export default {
  data() {
    return {
      firstName: null,
      lastName: null,
      preferredName: null,
      email: null,
      userClass: null,
      countries: [
        { name: "South Africa", value: "south-africa" },
        { name: "UK", value: "uk" },
        { name: "India", value: "india" },
        { name: "Botswana", value: "botswana" },
        { name: "USA", value: "usa" },
        { name: "Ghana", value: "ghana" }
      ],
      grade: null,
      currentSchoolIndex: 0,
      currentGradeIndex: 0,
      currentClassIndex: -1,
      subscriptionDate: null,
      countryName: null,
      changes: [],
      passwordReset: "",
      message: null,
      assessmentUpgrades: [],
      selectedUser: null
    };
  },
  mixins: [localizationMixin],
  computed: {
    ...mapState({
      usersRawData: state => state.globalStore.usersRawData,
      reflectiveData: state => state.globalStore.reflectiveData,
      filterValues: state => state.globalStore.filterLists,
      project: state => state.globalStore.activeFilterParams.project,
      filteredGrade: state => state.globalStore.activeFilterParams.grade,
      schoolIndex: state => state.globalStore.activeFilterParams.school,
      isInternal: state => state.globalStore.settings.isInternal
    }),
    ...mapGetters({
      getCurrentSchoolIndex: "globalStore/getCurrentSchoolIndex",
      getCurrentGradeIndex: "globalStore/getCurrentGradeIndex"
    }),
    schools() {
      if (this.project && this.filterValues.schools.filterBy) {
        const orderBySchool = this.filterValues.schools.value.map(
          schoolObject => schoolObject
        );

        //ordering the scools by alphabetical order
        const sortedBySchool = sortBy => (a, b) =>
          a[sortBy] > b[sortBy] ? 1 : -1;
        orderBySchool.sort(sortedBySchool("school"));
        return orderBySchool;
      }
      return null;
    },
    grades() {
      let result = [];
      if (this.schools && this.schools[this.currentSchoolIndex]) {
        let grs = Object.keys(this.schools[this.currentSchoolIndex].grades).map(
          grade => {
            return grade;
          }
        );
        this.addToGradesArray(1, 13, grs, result);
        return result;
      } else if (this.filterValues.tutors.filterBy) {
        return ["3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
      }
      return [];
    },
    classes() {
      if (
        this.schools &&
        this.schools[this.currentSchoolIndex].grades[
          this.grades[this.currentGradeIndex]
        ]
      ) {
        return this.schools[this.currentSchoolIndex].grades[
          this.grades[this.currentGradeIndex]
        ].classes;
      }
      return [];
    }
  },
  created() {
    if (this.selectedUsers.length <= 1) {
      this.email = this.changedUser.email;
      this.grade = this.changedUser.grade;
      this.lastName = this.changedUser.lastName;
      this.firstName = this.changedUser.firstName;
      this.preferredName = this.changedUser.preferredName;

      this.selectedUser = this.usersRawData.find(user => user._id == this.changedUser._id);
      this.assessmentUpgrades = this.selectedUser.assessmentStates.map(assessment => {
        return {
          newType: null,
          _id: assessment._id,
          type: assessment.type,
          subject: assessment.subject
        }
      });
    }

    this.currentSchoolIndex = this.getCurrentSchoolIndex;
    this.currentGradeIndex = this.getCurrentGradeIndex;
  },
  props: {
    isModalActive: { type: Boolean, default: false },
    selectedUsers: { type: Array, default: null },
    changedUser: { type: Object, default: null }
  },
  methods: {
    ...mapActions({
      upgradeLearnerAssessments: "globalStore/upgradeLearnerAssessments",
      updateLearnerPassword: "adminStore/updateLearnerPassword",
      loading: "SET_SCREEN_LOADING"
    }),
    async updatePassword() {
      try {
        if (
          this.passwordReset.trim() === "" ||
          this.passwordReset.trim().length < 6
        ) {
          this.passwordReset = "";
          this.$buefy.toast.open({
            message:
              "Failed to update learner password. Password must be more than 5 characters.",
            type: "is-danger",
            duration: 4000
          });
        } else {
          this.loading(true);
          const payload = {
            uid: this.changedUser._id,
            password: this.passwordReset
          };
          let results = await this.updateLearnerPassword(payload);
          this.passwordReset = "";
          this.loading(false);
          if (results) {
            this.$buefy.toast.open({
              message: "Learner password was successfully updated.",
              type: "is-success",
              duration: 4000
            });

            this.closeModal();
          } else {
            this.$buefy.toast.open({
              message: "Failed to update learner password",
              type: "is-danger",
              duration: 4000
            });
          }
        }

        //this.resetPassword(this.passwordReset, this.changedUser._id);
      } finally {
        //update later
      }
    },
    resetPassword(password, uid) {
      authservice.methods.resetPassword(password, uid).then(res => {
        console.log(res);
      });
    },
    saveChanges() {
      let values = {};
      let subscriptionUpdated = false;
      values._id = this.changedUser._id;
      values.subscription = { ...this.changedUser.subscription };
      if (this.firstName != this.changedUser.firstName) {
        this.firstName = this.changedUser.firstName;
        let name =
          this.firstName.charAt(0).toUpperCase() + this.firstName.slice(1);
        values.firstName = name;
      }
      if (this.lastName != this.changedUser.lastName) {
        this.lastName = this.changedUser.lastName;
        let name =
          this.lastName.charAt(0).toUpperCase() + this.lastName.slice(1);
        values.lastName = name;
      }
      if (this.email != this.changedUser.email) {
        this.email = this.changedUser.email;
        if (this.email.indexOf(" ") >= 0) {
          this.$buefy.toast.open({
            message:
              "Failed to update learner email. Email should not contain spaces.",
            type: "is-danger"
          });
        } else if (this.countCharacter(this.email, "@") > 1) {
          this.$buefy.toast.open({
            message:
              "Failed to update learner email. Email contains more than one @ symbol.",
            type: "is-danger"
          });
        } else if (this.email.split("@")[1].split(".")[0].length < 1) {
          this.$buefy.toast.open({
            message:
              'Failed to update learner email. Email requires text between "." and "@" symbols.',
            type: "is-danger"
          });
        } else if (!this.validateEmail(this.email)) {
          this.$buefy.toast.open({
            message:
              "Failed to update learner email. Email not in correct format.",
            type: "is-danger"
          });
        } else {
          values.email = this.email;
        }
      }
      if (this.grade) {
        values.grade = parseInt(this.grade);
        // let changeAssessment = this.checkForAssessmentChange(
        //   this.grade,
        //   null,
        //   false
        // );
        // if (changeAssessment !== "Cancel") {
        //   if (changeAssessment !== "none") {
        //     values.changeAssessment = true;
        //   }
        //   values.grade = parseInt(this.grade);
        // }
      }
      if (this.userClass) {
        values.class = this.userClass;
      }
      if (this.preferredName != this.changedUser.preferredName) {
        this.preferredName = this.changedUser.preferredName;
        let name =
          this.preferredName.charAt(0).toUpperCase() +
          this.preferredName.slice(1);
        values.preferredName = name;
      }
      if (this.countryName) {
        values.country = this.countryName;
      }
      if (this.subscriptionDate) {
        subscriptionUpdated = true;
        values.subscription.endDate = this.subscriptionDate;
      }
      if (!subscriptionUpdated) {
        delete values.subscription;
      }
      if (Object.keys(values).length > 1) {
        this.$emit("passEditedUser", values);
      } else {
        this.closeModal();
      }
    },
    addToGradesArray(min, max, array, result) {
      array.forEach(element => {
        if (element >= min && element <= max) {
          result.push(element);
        }
      });
      return true;
    },
    saveMultiple() {
      console.log("SELECTED USERS: ", this.selectedUsers);
      this.selectedUsers.forEach(element => {
        let values = {};
        values._id = element._id;
        values.subscription = { ...element.subscription };
        let subscriptionUpdated = false;

        if (this.grade) {
          values.grade = parseInt(this.grade);
          // let changeAssessment = this.checkForAssessmentChange(
          //   this.grade,
          //   element,
          //   true
          // );
          // if (changeAssessment !== "Cancel") {
          //   if (changeAssessment !== "none") {
          //     values.changeAssessment = true;
          //   }
          //   values.grade = parseInt(this.grade);
          // }
        }
        if (this.userClass) {
          values.class = this.userClass;
        }
        if (this.countryName) {
          values.country = this.countryName;
        }
        if (this.subscriptionDate) {
          subscriptionUpdated = true;
          values.subscription.endDate = this.subscriptionDate;
        }
        if (!subscriptionUpdated) {
          delete values.subscription;
        }
        if (Object.keys(values).length > 1) {
          this.$emit("passEditedUser", values);
        } else {
          this.closeModal();
        }
      });
    },
    checkForAssessmentChange(newGrade, user, multiple) {
      let currentAssessment;
      let newAssessment = "";

      if (multiple) {
        // const learners = this.selectedUsers;
        // const sameGrade = learners.filter(learner => learner.grade === learners[0].grade).length === learners.length;

        // if (!sameGrade) {
        //   confirm(
        //     "Make sure you select users at the same grade"
        //   );

        //   return "Cancel";
        // }

        currentAssessment = user.assessmentStates[0].type;
      } else {
        currentAssessment = this.changedUser.assessmentStates[0].type;
      }

      if (newGrade <= 4) {
        newAssessment = "MATHS_JUNIOR_PRIMARY";
      } else if (newGrade <= 7) {
        newAssessment = "MATHS_SENIOR_PRIMARY";
      } else if (newGrade <= 12) {
        newAssessment = "MATHS_JUNIOR_HIGH";
      } else if (newGrade === 13) {
        newAssessment = "MATHS_ADULT_NUMERACY";
      }

      if (currentAssessment != newAssessment) {
        if (
          confirm(
            `Are you sure you want to make this change? This change in grade will result in ${
              multiple ? user.email : this.changedUser.email
            }'s assessment type being updated.`
          )
        ) {
          return newAssessment;
        } else {
          return "Cancel";
        }
      } else {
        return "none";
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },
    validateEmail(val) {
      var re = /\S+@\S+\.\S+/;
      return re.test(val);
    },
    countCharacter(str, letter) {
      var letter_Count = 0;
      for (var position = 0; position < str.length; position++) {
        if (str.charAt(position) == letter) {
          letter_Count += 1;
        }
      }
      return letter_Count;
    },

    // UPDATE SINGLE ASSESSMENT UPGRADE FOR LEARNERS
    getUpgradeOptions(assessmentState) {
      const options = [];
      const currentType = assessmentState.type;

      if (assessmentState.subject === "MATHS") {
        options.push("MATHS_JUNIOR_PRIMARY", "MATHS_SENIOR_PRIMARY", "MATHS_JUNIOR_HIGH", "MATHS_ADULT_NUMERACY");
      } else if (assessmentState.subject === "ENGLISH") {
        options.push("ENGLISH_SENIOR_PRIMARY", "ENGLISH_JUNIOR_HIGH");
      }

      return options;
    },

    isDisabledOption(assessmentState, option) {
      const currentType = assessmentState.type;
      const options = this.getUpgradeOptions(assessmentState);
      const indexOfCurrent = options.indexOf(currentType);
      const indexOfOption = options.indexOf(option);

      // Disable options that are more than one level upgrade or downgrade
      if (Math.abs(indexOfCurrent - indexOfOption) > 1) {
        return true;
      }

      // Disable the current assessment type
      if (option === currentType) {
        return true;
      }

      return false;
    },
    async processUpgrades() {
      const payload = {
        userId: this.selectedUser._id,
        assessmentUpgrades: this.assessmentUpgrades.filter(o => o.newType != null)
      };

      const upgradeRes = await this.upgradeLearnerAssessments(payload);

      this.$buefy.toast.open({
        message: "Learner Assessments successfully upgraded.",
        type: "is-success",
        duration: 4000
      });

      this.$emit("closeModal");
    }
  }
};
</script>
